import { getSonList } from '@/api/common'
const state = {
    // 特惠仓商品
    stockNoByDiscount : ''
}

const mutations = {
    setStockNoByDiscount (state, value) {
        state.stockNoByDiscount = value
    }
}

const actions = {
    // 获取商品上架专区
    async getStockNo ({ commit }) {
        try {
            const response = await getSonList({ mark: 'stock_no_list' })
            let data = response.data
            let result = data.filter(item=> item.mark === "stock_no_discount")
            // 优惠专区的值
            let stockNoByDiscount = result.length >0 ? result[0].description : ""
            commit('setStockNoByDiscount', stockNoByDiscount)
        } catch (error) {
            console.error(error)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
